module.exports = __webpack_public_path__ + "images/graphic-mall-2_b6b3cb7b0cbc12e498b3f0dc1526366d.png";